import type { PlaycastMessage, PlaycastMessageInputSetPaused, PlaycastMessageInputToggleFilters, PlaycastMessageSource } from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'input';

export const setPaused = (hostId: string, paused: boolean, userAuth?: string): PlaycastMessage<PlaycastMessageInputSetPaused> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageInputSetPaused = {
    target,
    action: 'setPaused',
    isReply: false,
    message: {
      paused,
    },
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageInputSetPaused>;
};

export const toggleFilters = (
  hostId: string,
  filters: {
    keyboard: boolean;
    mouse: boolean;
    gamepad: boolean;
    rebootIfSafeAfterGuestModeExit?: boolean;
    exitGuestModeAfterAdminSession?: boolean;
  },
  userAuth?: string,
): PlaycastMessage<PlaycastMessageInputToggleFilters> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageInputToggleFilters = {
    target,
    action: 'toggleFilters',
    isReply: false,
    message: filters,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageInputToggleFilters>;
};
